import { useState, useEffect } from "react";
import InputSubTags from "../InputSubTags/InputSubTags";
import addIcon from "../../../../../assets/img/addicon.svg";

const InputTag = ({ tagsVariation, editVariation, variationId, titleVariation }) => {
  const [inputOpened, setInputOpened] = useState(false);
  const [subInputOpened, setSubInputOpened] = useState(false);
  const [subTagsTitle, setSubTagsTitle] = useState(tagsVariation);

  useEffect(() => {}, [subTagsTitle]);

  const openInput = () => {
    setInputOpened(true);
    setTimeout(() => {
      const inputVariationtitle = document.getElementById("input-variation-title-tag");
      if (inputVariationtitle) inputVariationtitle.focus();
    }, 100);
  };

  const openSubInput = () => {
    setSubInputOpened(true);
    setTimeout(() => {
      const inputVariationTagtitle = document.getElementById("input-variation-title-sub-tag");
      if (inputVariationTagtitle) inputVariationTagtitle.focus();
    }, 100);
  };

  const removeTag = (id, index) => {
    subTagsTitle.splice(index, 1);
    setSubTagsTitle([...subTagsTitle]);
    editVariation(titleVariation, variationId, [...subTagsTitle]);
  };

  const inputTitle = (event) => {
    // console.log(event);
    event.preventDefault();
    if (event.type === "keyup") {
      if (event.key === "Enter") {
        const value = event.target.value;
        if (value === "") {
          setInputOpened(false);
          setSubInputOpened(false);
          return;
        }
        if (subTagsTitle) {
          setSubTagsTitle([...subTagsTitle, { name: value }]);
          editVariation(titleVariation, variationId, [...subTagsTitle, { name: value }]);
        } else {
          setSubTagsTitle([{ name: value }]);
          editVariation(titleVariation, variationId, { name: value });
        }
        event.target.value = "";
        setInputOpened(false);
        openSubInput();
      }
    }
  };
  return (
    <>
      <div className="bg-white p-2 col-12 rounded-1">
        <div className="border-0 c-pointer" onClick={() => openInput()}>
          {!subTagsTitle?.length ? (
            <>
              {inputOpened ? (
                <>
                  <input
                    id="input-variation-title-tag"
                    className="border-0 ff-univanova fz-16 c-pointer p-2 form-control m-1 text-cl-black-4 shadow-none"
                    onKeyUp={(event) => inputTitle(event)}
                    onBlur={() => setInputOpened(false)}
                  ></input>
                </>
              ) : (
                <>
                  <div className="border-0  ff-univanova fz-16 c-pointer m-1 p-2 form-control  text-cl-black-4 d-flex align-items-center">
                    <img alt="delete variation" className="me-2" src={addIcon} />
                    <span>
                      Adicione e pressione <strong>Enter</strong> para adicionar uma nova tag
                    </span>
                  </div>
                </>
              )}
            </>
          ) : (
            <>
              <div className=" d-inline-flex align-items-center">
                <div className="d-flex flex-wrap">
                  {subTagsTitle.map((tagTitle, index) => (
                    <InputSubTags
                      title={tagTitle.name}
                      subTagsId={tagTitle._id}
                      removeTag={removeTag}
                      index={index}
                      key={tagTitle.name + index}
                    />
                  ))}
                  {subInputOpened ? (
                    <div className="d-flex align-items-center">
                      <input
                        id="input-variation-title-sub-tag"
                        className="border-0 ff-univanova fz-16 c-pointer form-control py-1 m-2 text-cl-black-4 shadow-none"
                        onKeyUp={(event) => inputTitle(event)}
                        onBlur={() => setSubInputOpened(false)}
                      ></input>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center ">
                      <span
                        className="border-0 ff-univanova fz-16 c-pointer py-1 m-2 form-control addtag text-nowrap"
                        onClick={() => openSubInput()}
                      >
                        <i className="bi bi-plus-lg me-2  fz-16"></i>
                        Add tag
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default InputTag;
